import { getImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/getImage";
export var searchProductImagePropsILeanProductTileAdapter = function(productTile, productSearchString, spellCorrectedQuery) {
    var _productTile_product, _productTile_product1;
    return {
        productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        productName: (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.name,
        image: getImage(productTile),
        productSearchString: productSearchString,
        spellCorrectedQuery: spellCorrectedQuery
    };
};
